import React from "react";
import Button from "material-ui/Button";
import { Link } from "react-router-dom";
import { withStyles } from "material-ui/styles";
import styles from "./styles";
import { toast } from "react-toastify";

import Title from "../ui/title";
import Content from "../ui/content";

import JobHeader from "../common/jobs/jobHeader";
import NoData from "../nodata";

import SplitView from "../splitview";
import Context from "./context/";
import Toolbar from "./toolbar/";
import Back from "../ui/back";

import NewJob from "./new";

import NewCustorg from "../common/custorg/new";
import CustorgLogo from "../common/custorg/logo";
import { isSignalTEK10GType } from "../../common/utils";

import LantekUpload from "./lantekupload";
import CometUpload from "./cometupload";
import { removeLogo } from "../../common/storage";
import ConfirmDialog from "../common/dialog/confirm";
import ReportGen from "../job/reportgen";
import ExportJob from "../job/exportjob";


import ListAttachments from "../common/jobandtestattachments/list";
import UploadAttachment from "../common/jobandtestattachments/add";
import ImportTests from "./importTest";
import Treeview from "../treeview";
import RefreshSignalR from "../signalr/refresh-signalr";
import {
  treeview,
} from "../../redux/actions";
import { setMonitoringJobsTableChange, setJobsTableChanged, setSelectedNode, treeviewEditJobReset } from "../../redux/actions/treeviewActions";
import { resetJobTreeview } from "../../redux/actions/jobActions";
import {connect} from "react-redux";

class Jobs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pendingJobsFound: false,
      showConfirmDelete: false,
      currentJob: null,
      modal: null,
      customerModal: null,
      logoModal: null,
      uploadLantekModal: null,
      uploadCometModal: null,
      reportGenModal: null,
      exportJobModal: null,
      exportJobAction: null,
      contextMenu: false,
      pageno: null,
      pagesize: null,
      page: props.page,
      count: props.count,
      jobs: null,
      showLoadMore: false,
      jobAttachmentsModal: false,
      uploadModal: false,
      search: [],
      filter: null,
      imageGenerationFailed: {
        showImageReGenerate: false,
        imageFailedJobId: null
      },
      syncChange: false,
      importTestModal: false,
      jobOrderSelectOptions: {
        "Job title: A-Z (default)": {
          name: "Job title: A-Z (default)",
          field: "name",
          sorttype: "asc"
        },
        "Job title Z-A": {
          name: "Job title Z-A",
          field: "name",
          sorttype: "desc"
        },
        "Date: New to old": {
          name: "Date: New to old",
          field: "createdat",
          sorttype: "desc"
        },
        "Date: Old to new": {
          name: "Date: Old to new",
          field: "createdat",
          sorttype: "asc"
        }/*,
        "Customer title: A-Z": {
          name: "Customer title: A-Z",
          field: "customer_name",
          sorttype: "asc"
        },
        "Customer title: Z-A": {
          name: "Customer title: Z-A",
          field: "customer_name",
          sorttype: "desc"
        }*/
      },
      jobsDefaultOrder: props.jobsDefaultOrder || {
        name: "Date: New to old",
        field: "createdat",
        sorttype: "desc"
      },
      showSurveyBtn: true,
      includeChildren: false,
      nodeId: '',
      testCountForTreeview: null,
      jobDeleted: false,
      signalRConnectionActive: false
    };

    this.showCustomerModal = this.showCustomerModal.bind(this);
    this.closeCustomerModal = this.closeCustomerModal.bind(this);
    this.showLogoModal = this.showLogoModal.bind(this);
    this.closeLogoModal = this.closeLogoModal.bind(this);
    this.loadMoreJobs = this.loadMoreJobs.bind(this);
    this.editJob = this.editJob.bind(this);
    this.view = this.view.bind(this);
    this.del = this.del.bind(this);
    this.deleteJob = this.deleteJob.bind(this);
    this.showConfirmDel = this.showConfirmDel.bind(this);
    this.hideConfirmDel = this.hideConfirmDel.bind(this);
    this.showUploadLantekModal = this.showUploadLantekModal.bind(this);
    this.closeUploadLantekModal = this.closeUploadLantekModal.bind(this);
    this.onUploadLantekFiles = this.onUploadLantekFiles.bind(this);
    this.onUploadCometFiles = this.onUploadCometFiles.bind(this);
    this.showUploadCometModal = this.showUploadCometModal.bind(this);
    this.closeUploadCometModal = this.closeUploadCometModal.bind(this);
    this.onTableStateChanged = this.onTableStateChanged.bind(this);
  };

  showCustomerModal() {
    this.setState({
      customerModal: true
    });
  }

  closeCustomerModal(reset) {
    //reset && this.props.reset()
    this.setState({
      customerModal: false
    });
  }

  showLogoModal() {
    this.setState({
      logoModal: true
    });
  }

  closeLogoModal(reset) {
    //reset && this.props.reset()
    this.setState({
      logoModal: false
    });
  }

  showUploadLantekModal() {
    this.setState({
      uploadLantekModal: true
    });
  }
  closeUploadLantekModal() {
    this.setState({
      uploadLantekModal: false
    });
  }

  showUploadCometModal() {
    this.setState({
      uploadCometModal: true
    });
  }
  closeUploadCometModal() {
    this.setState({
      uploadCometModal: false
    });
  }

  showImportTestModal = () => {
    this.setState({
      importTestModal: true
    });
  };

  closeImportTestModal = () => {
    this.setState({
      importTestModal: false,
      uploadCometModal: false,
      uploadLantekModal: false
    });
  };

  add() {
    this.props.loadStandardAndDevicesAndCustom();
    // if (!this.props.customers) {
    this.props.getCustomers({
      pageno: 0,
      pagesize: 0
    });
    // }
    this.setState({
      modal: true
    });

    if (this.props.edit) {
      this.props.cancelEdit();
    }
  }

  close() {
    this.setState({
      modal: false
    });
    this.props.cancelEdit();
  }

  logoStored() {
    this.setState({
      logoStored: true,
      customerModal: false
    });
  }
  del(e, job) {
    e.preventDefault();
    this.showConfirmDel(job);
  }
  showConfirmDel(job) {
    this.setState({
      currentJob: { ...job },
      showConfirmDelete: true
    });
  }
  hideConfirmDel() {
    this.setState({
      currentJob: null,
      showConfirmDelete: false
    });
  }
  deleteJob() {
    this.props.deleteJob(
      this.state.currentJob.id,
      this.props.selectedCustomerId
    );
    this.hideConfirmDel();
    this.setState({
      jobDeleted: true
    });
  }

  showReportFromTreeview = (job) => {
    this.setState({
      includeChildren: job.includeLowerRecords,
      nodeId: job.nodeId,
      nodeTestCount: job.nodeTestCount
    });

    if (job.deviceid && isSignalTEK10GType(job.deviceid)) {
      this.props.getCustomers({
        pageno: 0,
        pagesize: 0
      });
      this.setState({
        currentJob: { ...job },
        reportGenModal: true
      });
      this.setState({
        imageGenerationFailed: {
          showImageReGenerate: false,
          imageFailedJobId: null
        }
      });
    } else {
      this.props
        .checkForReportForTreeview({ jobId: job.id, nodeId: job.nodeId, includeChildren: job.includeLowerRecords })
        .then(response => {
          this.setState({
            testCountForTreeview: job.nodeTestCount
          });
          if (response.testnames.length === 0) {
            this.props.getCustomers({
              pageno: 0,
              pagesize: 0
            });
            this.setState({
              currentJob: { ...job },
              reportGenModal: true
            });
            this.setState({
              imageGenerationFailed: {
                showImageReGenerate: false,
                imageFailedJobId: null
              }
            });
          } else {
            let testNames = null;
            if (response.testnames.length > 10) {
              testNames = response.testnames.slice(0, 10).join(" ");
            } else {
              testNames = response.testnames.join(" ");
            }
            if (response.imagegenerationfailed) {
              toast.error(
                ` ${this.props.translate(
                  "report_generate_failed_help"
                )} ${testNames}`,
                {
                  position: toast.POSITION.TOP_CENTER,
                  hideProgressBar: true
                }
              );
            } else {
              toast.info(
                ` ${this.props.translate("report_generate_help")} ${testNames}`,
                {
                  position: toast.POSITION.TOP_CENTER,
                  hideProgressBar: true
                }
              );
            }
            this.setState({
              imageGenerationFailed: {
                showImageReGenerate: response.imagegenerationfailed,
                imageFailedJobId: job.id
              }
            });
          }
        });
    }
  };

  showExportJob = (e, job, action) => {
    e.preventDefault();
    this.setState({
      currentJob: { ...job },
      exportJobModal: true,
      exportJobAction: action
    });
  }

  hideExportJob = () => {
    this.setState({
      currentJob: null,
      exportJobModal: false,
      exportJobAction: null
    });
  };

  exportJobRequest = data => {
    const { currentJob } = this.state;
    this.hideExportJob();
    if (data.action === "download") {
      this.props.downloadExportedJob(data.jobid, data.filetype === "CSV");
    }
    else {
      this.props.exportJob(data.jobid, data.filetype === "CSV");
    }
  }

  showReportGen = (e, job) => {
    e.preventDefault();
    if (job.deviceid && isSignalTEK10GType(job.deviceid)) {
      this.props.getCustomers({
        pageno: 0,
        pagesize: 0
      });
      this.setState({
        currentJob: { ...job },
        reportGenModal: true
      });
      this.setState({
        imageGenerationFailed: {
          showImageReGenerate: false,
          imageFailedJobId: null
        }
      });
    } else {
      this.props
        .checkForReport({ testids: [], selectall: true, jobid: job.id })
        .then(response => {
          if (response.testnames.length === 0) {
            this.props.getCustomers({
              pageno: 0,
              pagesize: 0
            });
            this.setState({
              currentJob: { ...job },
              reportGenModal: true
            });
            this.setState({
              imageGenerationFailed: {
                showImageReGenerate: false,
                imageFailedJobId: null
              }
            });
          } else {
            let testNames = null;
            if (response.testnames.length > 10) {
              testNames = response.testnames.slice(0, 10).join(" ");
            } else {
              testNames = response.testnames.join(" ");
            }
            if (response.imagegenerationfailed) {
              toast.error(
                ` ${this.props.translate(
                  "report_generate_failed_help"
                )} ${testNames}`,
                {
                  position: toast.POSITION.TOP_CENTER,
                  hideProgressBar: true
                }
              );
            } else {
              toast.info(
                ` ${this.props.translate("report_generate_help")} ${testNames}`,
                {
                  position: toast.POSITION.TOP_CENTER,
                  hideProgressBar: true
                }
              );
            }
            this.setState({
              imageGenerationFailed: {
                showImageReGenerate: response.imagegenerationfailed,
                imageFailedJobId: job.id
              }
            });
          }
        });
    }
  };
  hideReportGen = () => {
    this.setState({
      currentJob: null,
      reportGenModal: false
    });
  };

  generateReport = data => {
    const { currentJob: job, nodeId, includeChildren, testCountForTreeview } = this.state;
    const { lantekreportcount, cometreportcount } = this.props;

    data.nodeId = nodeId;
    data.includeChildren = includeChildren;

    if (testCountForTreeview) {
      job.totaltest = testCountForTreeview;
    }

    if (
      job &&
      job.deviceid &&
      job.deviceid.toLowerCase() === "comet_copper" &&
      data.type &&
      data.type.toLowerCase() !== "singleline" &&
      job.totaltest > cometreportcount
    ) {
      toast.error(
        this.props.translate("brief_report_too_many_tests", {
          value: cometreportcount
        }),
        {
          position: toast.POSITION.TOP_CENTER,
          hideProgressBar: true
        }
      );
      return;
    }
    if (
      job &&
      !job.deviceid &&
      data.type &&
      data.type.toLowerCase() !== "singleline" &&
      job.totaltest > lantekreportcount
    ) {
      toast.error(
        this.props.translate("brief_report_too_many_tests", {
          value: lantekreportcount
        }),
        {
          position: toast.POSITION.TOP_CENTER,
          hideProgressBar: true
        }
      );
      return;
    }
    this.props.generateReport(data);
    this.hideReportGen();
  };

  editJob(e, job) {
    e.preventDefault();
    this.props.loadStandardAndDevicesAndCustom();
    const { editJob } = this.props;
    editJob(job.id);
  }

  view(e, job) {
    e.preventDefault();
  }

  onUploadLantekFiles(files) {
    let self = this;
    this.props
      .uploadLantekFiles(files)
      .then(resp => {
        self.closeUploadLantekModal();
        self.closeImportTestModal();
      })
      .catch(errors => {
        console.log(errors);
      });
  }

  onUploadCometFiles(data) {
    let self = this;
    this.props
      .uploadCometFiles(data)
      .then(resp => {
        self.closeUploadCometModal();
        self.closeImportTestModal();
      })
      .catch(errors => {
        console.log(errors);
      });
  }

  loadMoreJobs(e) {
    e.preventDefault();
    const { loadMore, jobs, jobsDefaultOrder } = this.props;
    let { page, count, search } = this.state;
    page = Math.ceil(jobs.recordsfiltered / count) + 1;
    this.setState({
      page
    });
    loadMore(search, page, count, jobsDefaultOrder);
  }

  showAttachments = (e, job) => {
    e.preventDefault();
    this.setState({
      currentJob: { ...job },
      jobAttachmentsModal: true
    });
  };

  hideAttachments = e => {
    this.setState({
      currentJob: null,
      jobAttachmentsModal: false
    });
  };

  closeModal = reset => {
    this.setState({
      currentJob: null,
      jobAttachmentsModal: false
    });
  };

  componentDidMount()
  {
    if (this.props.jobsTableChanged === true) {
      this.onTableStateChanged();
    }
  }

  checkPendingJobs(jobs) {
    if (jobs && jobs.data && jobs.data.length > 0) {
      let pendingJobs = jobs.data.filter(j => j.pendingcount > 0);
      if (pendingJobs && pendingJobs.length > 0) {
        return true;
      }
    }
    return false;
  }

  componentWillMount() {
    this.props.resetJobTreeview(this.props);
  }

  componentWillReceiveProps(nextProps) {
    const { edit, jobs, form, count, filter, search, jobsTableChanged } = nextProps;
    if (edit) {
      this.setState({
        modal: true
      });
    }
    if (
      (jobs && jobs.data.length === 0) ||
      (jobs && jobs.recordsfiltered < count) ||
      (jobs && jobs.recordsfiltered === jobs.recordstotal)
    ) {
      this.setState({ showLoadMore: false });
    }
    if (jobs && jobs.recordsfiltered < jobs.recordstotal) {
      this.setState({ showLoadMore: true });
    }
    this.setState({ jobs });
    let pendingJobs = this.checkPendingJobs(jobs);
    if (pendingJobs != this.state.pendingJobsFound) {
      this.setState({ pendingJobsFound: pendingJobs });
      if (!pendingJobs && !this.props.jobsTableChanged) {
        console.log("No more pending jobs; refreshTreeview now");
        this.props.refreshTreeview(this.props);
      }
    }
    // if (jobs && page === 1) {
    //   this.setState({ jobs })
    // } else if (jobs) {
    //   jobs.data = [...this.state.jobs.data, ...jobs.data].reduce((x, y) => x.findIndex(e => e.id === y.id) < 0 ? [...x, y] : x, [])
    //   this.setState({ jobs })
    // }
    if (form && !edit) {
      this.setState({
        modal: false
      });
    }

    if (filter) {
      this.setState({ filter });
    }
    if (search) {
      this.setState({ search });
    }
  }

  showUplaodModal = () => {
    this.setState({
      uploadModal: true
    });
  };

  hideUplaodModal = () => {
    this.setState({
      uploadModal: false
    });
  };

  uploadFile = file => {
    const { currentJob } = this.state;
    const { uploadAttachment } = this.props;
    uploadAttachment(file, currentJob.id);
  };

  setSearchParams = (filter, params) => {
    const { start, jobsDefaultOrder, saveJobSearchFilter } = this.props;
    let { count } = this.state;

    start(params, 1, count, jobsDefaultOrder);
    this.setState({
      search: params,
      filter: filter,
      syncChange: false
    });
    saveJobSearchFilter(filter, params, true);
  };

  onChangeSync = id => {
    const { onSyncChange } = this.props;
    this.setState({ syncChange: true });
    onSyncChange(id);
  };

  refresh = () => {
    const { start, jobsDefaultOrder, saveJobSearchFilter } = this.props;
    let { count, search } = this.state;

    start(search, 1, count, jobsDefaultOrder);
  }

  changeJobsDefaultOrder = e => {
    const { start } = this.props;
    let { search, jobOrderSelectOptions } = this.state;
    this.setState({
      jobsDefaultOrder: jobOrderSelectOptions[e.target.value]
    });
    start(search, 1, 15, jobOrderSelectOptions[e.target.value]);
    this.props.updateJobsDefaultOrder(jobOrderSelectOptions[e.target.value]);
  };

  // openSurvey = () => {
  //   document.getElementById("smcx-sdk")
  //     ? document.getElementById("smcx-sdk").remove()
  //     : null;
  //   document.cookie =
  //     "smcx_0_last_shown_at=;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  //   (function(t, e, s, o) {
  //     var n, c, l;
  //     (t.SMCX = t.SMCX || []),
  //       e.getElementById(o) ||
  //         ((n = e.getElementsByTagName(s)),
  //         (c = n[n.length - 1]),
  //         (l = e.createElement(s)),
  //         (l.type = "text/javascript"),
  //         (l.async = !0),
  //         (l.id = o),
  //         (l.src =
  //           "https://widget.surveymonkey.com/collect/website/js/tRaiETqnLgj758hTBazgd93dCVVWbyat3Y9BWednUQZupPwa6dSRSmqjvM_2B_2B2FEU.js"),
  //         c.parentNode.insertBefore(l, c));
  //   })(window, document, "script", "smcx-sdk");
  //   this.setState({
  //     showSurveyBtn: false
  //   });
  // };

  render() {
    const {
      classes,
      translate,
      customers,
      devices,
      standards,
      custom,
      saveNewJob,
      saveEditJob,
      languages,
      create,
      customerId,
      getCustomer,
      customer,
      edit,
      prevSelectedDeviceid,
      setPrevSelectedDeviceid,
      jobs,
      form,
      attachments,
      getAttachments,
      deleteAttachment,
      attachmentDownload,
      onSyncChange,
      jobReload,
      selectedCustomerName,
      selectedCustomerId,
      clearAttachments,
      downloadCsv,
      rengernateImage,
      resetCustomer,
      exportJob,
      downloadExportedJob,
      validateLt4JobName,
      selectedLanguage,
      countryStates,
      editTreeviewJobId,
      fileUploadSettings,
    } = this.props;

    const {
      modal,
      page,
      showLoadMore,
      currentJob,
      filter,
      imageGenerationFailed,
      syncChange,
      jobsDefaultOrder,
      jobOrderSelectOptions,
      showSurveyBtn,
      jobDeleted,
      exportJobAction
    } = this.state;

    let allJobs = page === 1 ? jobs : { ...jobs, ...this.state.jobs };
    const jobsList = allJobs ? allJobs.data : [];

    if (editTreeviewJobId > 0) {
      this.props.loadStandardAndDevicesAndCustom();
      const { editJob } = this.props;
      editJob(editTreeviewJobId);
      this.props.treeviewEditJobReset(this.props);
    }

    let $modal = null;
    if (modal) {
      $modal = (
        <NewJob
          customers={customers}
          devices={devices}
          standards={standards}
          custom={custom}
          saveNewJob={saveNewJob}
          saveEditJob={saveEditJob}
          translate={translate}
          cancel={() => this.close()}
          addCustomer={() => this.showCustomerModal()}
          customerId={customerId}
          editJobData={edit}
          prevSelectedDeviceid={prevSelectedDeviceid}
          setPrevSelectedDeviceid={setPrevSelectedDeviceid}
          form={form}
          selectedCustomerId={selectedCustomerId}
        />
      );
    }

    let $customerModal = this.state.customerModal ? (
      <NewCustorg
        container="customers"
        languages={languages}
        mode="create"
        modal={this.state.customerModal}
        close={this.closeCustomerModal}
        create={create}
        addLogo={this.showLogoModal}
        removeLogo={removeLogo}
        translate={translate}
        customer={customer}
        reset={resetCustomer}
        countryStates={countryStates}
      />
    ) : null;

    let $logoModal = this.state.logoModal ? (
      <CustorgLogo
        container="customers"
        languages={languages}
        modal={this.state.logoModal}
        mode="create"
        customerId={customerId}
        customer={customer}
        cancel={this.closeLogoModal}
        translate={translate}
        logoStored={this.closeLogoModal}
      />
    ) : null;

    let confirmDeleteText = translate("job_delete_confirm_text", {
      name:
        this.state.currentJob && this.state.currentJob.name
          ? this.state.currentJob.name
          : ""
    });

    let $uploadLantekModal = this.state.uploadLantekModal ? (
      <LantekUpload
        translate={translate}
        onClose={this.closeUploadLantekModal}
        onUpload={this.onUploadLantekFiles}
        fileUploadSettings={fileUploadSettings}
      />
    ) : null;

    let $uploadCometModal = this.state.uploadCometModal ? (
      <CometUpload
        translate={translate}
        onClose={this.closeUploadCometModal}
        onUpload={this.onUploadCometFiles}
        validateLt4JobName={validateLt4JobName}
        fileUploadSettings={fileUploadSettings}
      />
    ) : null;

    let $exportJobModal = null;
    if (this.state.exportJobModal) {
      $exportJobModal = (
        <ExportJob
          job={currentJob}
          action={exportJobAction}
          language={selectedLanguage}
          translate={translate}
          cancel={() => this.hideExportJob()}
          submit={data => this.exportJobRequest(data)}
        />
      );
    }

    let $reportGenModal = null;
    if (this.state.reportGenModal) {
      $reportGenModal = (
        <ReportGen
          job={currentJob}
          language={selectedLanguage}
          translate={translate}
          customers={customers}
          languages={languages}
          customer={customer}
          getCustomer={getCustomer}
          selectedtotal={this.state.testCountForTreeview ? this.state.testCountForTreeview : currentJob.totaltest}
          selectAll={true}
          cancel={() => this.hideReportGen()}
          submit={data => this.generateReport(data)}
          selectedCustomerId={selectedCustomerId}
          countryStates={countryStates}
        />
      );
    }

    let $jobAttachmentsModal = this.state.jobAttachmentsModal ? (
      <ListAttachments
        translate={translate}
        close={this.closeModal}
        jobid={currentJob.id}
        attachments={attachments}
        getAttachments={getAttachments}
        hideUplaodModal={this.hideUplaodModal}
        showUplaodModal={this.showUplaodModal}
        deleteAttachment={deleteAttachment}
        attachmentDownload={attachmentDownload}
        clearAttachments={clearAttachments}
      />
    ) : null;

    let $fileUploadModal = this.state.uploadModal ? (
      <UploadAttachment
        translate={translate}
        jobid={currentJob.id}
        hideUplaodModal={this.hideUplaodModal}
        uploadFile={this.uploadFile}
        fileUploadSettings={fileUploadSettings}
      />
    ) : null;

    let $showImport = this.state.importTestModal ? (
      <ImportTests
        translate={translate}
        onClose={this.closeImportTestModal}
        upload={this.showUploadLantekModal}
        uploadComet={this.showUploadCometModal}
      />
    ) : null;

    return (
      <div className={classes.divContent}>
        <Title
          title={translate("general_jobs")}
          custTitle={
            selectedCustomerName && (
              <Back
                title={translate("general_customers")}
                link={"/customers"}
              />
            )
          }
          custName={
            selectedCustomerName && (
              <Back title={selectedCustomerName} link={" "} />
            )
          }
          toolbar={
            <Toolbar
              translate={translate}
              toggle={() => this.toggle()}
              add={() => this.add()}
              importTest={() => this.showImportTestModal()}
              changeJobsDefaultOrder={this.changeJobsDefaultOrder}
              jobsDefaultOrder={jobsDefaultOrder}
              jobOrderSelectOptions={jobOrderSelectOptions}
              signalRUpdate={this.state.signalRConnectionActive}
            />
          }
        />
        <SplitView show={true} left={<Treeview jobDeleted={jobDeleted} jobs={jobs} translate={translate} showReportModal={this.showReportFromTreeview} showAddJob={true} jobsOrder={this.state.jobsDefaultOrder} selectedCustomerId={selectedCustomerId} refreshTest={this.refresh}></Treeview>}>
          <Content
          ctx={
            <Context
              translate={translate}
              setSearchParams={this.setSearchParams}
              customers={customers}
              filter={filter}
              syncChange={syncChange}
              deviceTypes={devices}
            />
          }
          drawerTitle={"search"}
          open={this.state.contextMenu}
          toggle={() => this.toggle()}
          translate={translate}
        >

            {jobsList && jobsList.length > 0 ? (
              jobsList.map((job, index) => {
                return (
                  <JobHeader
                    title="jobspage"
                    translate={translate}
                    key={index}
                    job={job}
                    reportGen={this.showReportGen}
                    edit={this.editJob}
                    del={this.del}
                    view={this.view}
                    attachments={this.showAttachments}
                    onSyncChange={id => this.onChangeSync(id)}
                    jobReload={jobReload}
                    downloadCsv={downloadCsv}
                    rengernateImage={rengernateImage}
                    imageGenerationFailed={imageGenerationFailed}
                    isSelectionShow={false}
                    exportJob={this.showExportJob}
                    downloadExportedJob={this.showExportJob}
                  />
                );
              })
            ) : (
              <NoData translate={translate} noDataText="no_job_data_lt3" />
            )}

          {showLoadMore ||
          (jobs && jobs.recordsfiltered < jobs.recordstotal) ? (
            <Button
              variant="raised"
              className={classes.button}
              onClick={this.loadMoreJobs}
            >
              {translate("job_load_more")}
            </Button>
          ) : null}
          {/* {showSurveyBtn == true && (
            <div>
              <button
                style={{
                  font: "12px Helvetica, sans-serif",
                  color: "#999",
                  textDecoration: "none"
                }}
                onClick={() => this.openSurvey()}
              >
                {translate("survey_btn_text")}
              </button>
            </div>
          )} */}
          {$modal}
          {$customerModal}
          {$logoModal}
          {$uploadLantekModal}
          {$reportGenModal}
          {$exportJobModal}
          {$jobAttachmentsModal}
          {$fileUploadModal}
          {$uploadCometModal}
          {$showImport}
          <ConfirmDialog
            open={this.state.showConfirmDelete}
            title={translate("job_delete_confirm_title")}
            contentText={confirmDeleteText}
            contentSecondaryText={translate("general_confirmation_help_2")}
            okText={translate("general_confirm")}
            cancelText={translate("general_cancel")}
            onOk={this.deleteJob}
            onCancel={this.hideConfirmDel}
          />
        </Content>
        </SplitView>
        <RefreshSignalR
          onTableStateChanged={() => {
            this.onTableStateChanged();
          }}
          onSignalRConnected={() => {
            this.setSignalR(true);
          }}
          onSignalRDisconnected={() => {
            this.setSignalR(false);
          }}
          table={"jobs"}
          refreshRate={10000}
        />
      </div>
    );
  }


  setSignalR(connected) {
    this.props.setMonitoringJobsTableChange(connected);
    this.setState({
      signalRConnectionActive: connected
    });
  }

  toggle() {
    this.props.getCustomers({
      pageno: 0,
      pagesize: 0
    });
    this.setState({
      contextMenu: !this.state.contextMenu
    });
  }

  onTableStateChanged() {
    console.log("Jobs table changed");
    this.props.setJobsTableChanged(false);
    this.refresh();
    let updateTreeview = true;
    if (this.state.pendingJobsFound) {
      console.log("Found pending jobs; skip refreshTreeview");
      updateTreeview = false;
    }
    else {
      console.log("no pending jobs");
    }
    if (updateTreeview) {
      console.log("refreshTreeview now");
      this.props.refreshTreeview(this.props);
    }
  }
}

// For some reason, this is needed
const mapStateToProps = (state) => ({
  editTreeviewJobId: state.treeviewReducer.editTreeviewJobId,
  jobsTableChanged: state.treeviewReducer.jobsTableChanged,
  fileUploadSettings: state.appSettingReducer.fileUploadSettings,
});

const mapDispatchToProps = (dispatch, props) => ({
  resetJobTreeview: (props) => {
    dispatch(resetJobTreeview());
  },
  refreshTreeview: (props) => {
    dispatch(treeview('all'));
  },
  setSelectedNode: (nodeId) => {
    dispatch(setSelectedNode(nodeId));
  },
  treeviewEditJobReset: (props) => {
    dispatch(treeviewEditJobReset());
  },
  setMonitoringJobsTableChange: (monitoring) => {
    dispatch(setMonitoringJobsTableChange(monitoring));
  },
  setJobsTableChanged: (changed) => {
    dispatch(setJobsTableChanged(changed));
  }
});

export default
connect(mapStateToProps, mapDispatchToProps)
(withStyles(styles)(Jobs));



// WEBPACK FOOTER //
// ./src/components/jobs/index.js